import React from 'react';

const h = React.createElement;

/**
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {React.CSSProperties} [p.style]
 */
export function CardContent({ children, style }) { return h('div', { style: { marginTop: 'var(--stack-gap)', ...style } }, children); }
